export default "__VITE_ASSET__CK1OZMkh__"